import React from 'react';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaUniversity, FaGraduationCap, FaIdBadge, FaGlobe } from 'react-icons/fa';
import './Contact.css';
import { professorData } from '../data';

export default function Contact() {
  const { contact, profiles, university, department, location, metrics } = professorData;

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Get in Touch</span>
          <h2 className="section-title">Contact Information</h2>
          <div className="section-rule"></div>
        </div>

        <div className="contact-modern__grid">
          {/* Left Column: Premium Profile Card */}
          <div className="contact-modern__profile-card">
            <div className="contact-modern__profile-bg"></div>
            <div className="contact-modern__profile-content">
              <h3 className="contact-modern__name">Prof. Dr. B. Jagan Mohan Reddy</h3>
              <p className="contact-modern__title">{department}</p>
              
              <div className="contact-modern__details">
                <div className="contact-modern__detail-item">
                  <div className="icon-wrapper"><FaUniversity /></div>
                  <div className="detail-text">{university}</div>
                </div>
                <div className="contact-modern__detail-item">
                  <div className="icon-wrapper"><FaMapMarkerAlt /></div>
                  <div className="detail-text">{location}</div>
                </div>
              </div>

              <div className="contact-modern__methods">
                <a href={`tel:${contact.mobile}`} className="contact-modern__method">
                  <div className="method-icon"><FaPhoneAlt /></div>
                  <div className="method-info">
                    <span className="method-label">Mobile / Work</span>
                    <span className="method-val">{contact.mobile}</span>
                  </div>
                </a>
                
                <a href={`mailto:${contact.email1}`} className="contact-modern__method">
                  <div className="method-icon"><FaEnvelope /></div>
                  <div className="method-info">
                    <span className="method-label">Official Email</span>
                    <span className="method-val">{contact.email1}</span>
                  </div>
                </a>

                <a href={`mailto:${contact.email2}`} className="contact-modern__method">
                  <div className="method-icon"><FaEnvelope /></div>
                  <div className="method-info">
                    <span className="method-label">Personal Email</span>
                    <span className="method-val">{contact.email2}</span>
                  </div>
                </a>
              </div>

              <div className="contact-modern__profiles">
                <p className="profiles-label">Academic Profiles</p>
                <div className="profiles-links">
                  <a href={profiles.googleScholar} target="_blank" rel="noopener noreferrer" className="profile-btn scholar">
                    <FaGraduationCap /> Google Scholar
                  </a>
                  <a href={profiles.orcid} target="_blank" rel="noopener noreferrer" className="profile-btn orcid">
                    <FaIdBadge /> ORCID
                  </a>
                  <a href={profiles.vidwan} target="_blank" rel="noopener noreferrer" className="profile-btn vidwan">
                    <FaGlobe /> Vidwan
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Stats & Location */}
          <div className="contact-modern__right">
            <div className="contact-modern__stats-card">
              <h4 className="stats-card__title">Career Highlights</h4>
              <div className="stats-card__grid">
                {[
                  { label: 'Experience', val: `${metrics.experience}+ Yrs` },
                  { label: 'Publications', val: metrics.publications },
                  { label: 'Citations', val: metrics.citations },
                  { label: 'h-Index', val: metrics.hIndex },
                  { label: 'i10-Index', val: metrics.i10Index },
                  { label: 'PhD Scholars', val: metrics.phdsAwarded + metrics.phdsOngoing },
                  { label: 'Patents', val: metrics.patents },
                  { label: 'Books', val: metrics.books },
                  { label: 'Conferences', val: metrics.conferences },
                ].map((s, i) => (
                  <div key={i} className="stats-modern__item">
                    <div className="stats-modern__val">{s.val}</div>
                    <div className="stats-modern__label">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="contact-modern__location-card">
              <div className="location-card__icon">
                <FaUniversity />
              </div>
              <div className="location-card__info">
                <h4>Adikavi Nannaya University</h4>
                <p>Department of Chemistry</p>
                <p className="location-address">Rajahmundry, Andhra Pradesh, India</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
